/**
 * Builds a value for the `data-selector` attribute used as a stable hook for A/B testing (Optimizely).
 * Names follow the Figma layer naming, e.g. `global.module.flexible.title`.
 * Returns undefined when no base is given so the attribute is omitted entirely.
 */
const getSelector = (base?: string, ...parts: string[]): string | undefined =>
    base ? [base, ...parts].join('.') : undefined;

export default getSelector;
